import { MdEdit, MdDelete } from 'react-icons/md'
import React, { useEffect, useState } from 'react'
import GetAutoSuggestionsForTagsService from '../../Services/Queries/GetAutoSuggestionsForTagsService'
import DeleteTagService from '../../Services/Queries/DeleteTagService'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'
import { MdOutlineClear } from 'react-icons/md'
import { contentTypesForTags } from '../Data/StaticData'
function AllTags() {
  const [tagsList, setTagsList] = useState([])
  const [SearchedInput, setSearchedInput] = useState('')
  const [headers, setHeaders] = useState([])
  const [totalLists, setTotalLists] = useState()
  const [selectedTab, setSelectedTab] = useState('Persons')
  const [filters, setFilters] = useState({
    mode: 'TFIDB',
    tagType: 'good',
    contentType: 'person',
    search: '',
    limit: 10,
    from: 0,
  })
  const [TagTypeValue, setTagTypeValue] = useState(filters.tagType)
  console.log(totalLists, 'totalListstotalLists')

  console.log(filters, 'aScdatadatadatadataadsc')
  const getData = async () => {
    const filtersInput = filters
    if (filters.mode === 'TFIDB') {
      delete filtersInput.tagType
    } else {
      filtersInput.tagType = TagTypeValue
    }

    console.log(filtersInput, 'aScdatadatadatadataadsc11')
    const data = await GetAutoSuggestionsForTagsService(filtersInput)
    console.log(data, 'aScdatadatadatadataadsc')
    const newData = data.data.map(item => {
      if (filters.mode === 'TFIDB') {
        const { PK, SK, mode, tagType, __typename, ...rest } = item
        return rest
      }

      const { PK, SK, mode, __typename, ...rest } = item
      return rest
    })

    setTagsList(data.data)
    setTotalLists(data.total)

    setHeaders(Object.keys(newData && newData[0])) // Assuming all objects have the same keys
  }

  const clearSearch = () => {
    filters.search = ''
    setSearchedInput('')
    getData()
  }

  console.log(filters, 'filtersfiltersfilters')
  const handleFilterChangeForTabs = (item, tagType) => {
    setSelectedTab(item.name)
    console.log(item, filters, 'filtersfiltersfilters12121')

    setFilters({
      ...filters,
      from: 0,
      tagType,
      contentType: item.Type,
      mode: item.Mode,
    })
  }

  const handleFilterChange = e => {
    const { name, value } = e.target
    if (name === 'search') {
      setSearchedInput(value)
    }

    console.log(name, value, 'asdatadatadatadata')
    if (name === 'tagType') {
      setTagTypeValue(value)
    }

    setFilters({ ...filters, [name]: value })
    // getData({ ...filters, [name]: value })
  }

  // console.log(tagsList, 'deleteTagdeleteTag')
  const YesRemovetag = async item => {
    const deleteTag = await DeleteTagService({ PK: item.PK, SK: item.SK })

    if (deleteTag.data.deleteTag.statusCode === '200') {
      toast.success(deleteTag.data.deleteTag.statusMessage, ToastStyle)
      const afterRemovingtag = tagsList.filter(data => data.PK !== item.PK)
      setTagsList(afterRemovingtag)
      setTimeout(async () => {
        const data = await GetAutoSuggestionsForTagsService(filters)
        console.log(data, 'aScdatadatadatadataadscadscas')
        setTotalLists(data.total)
      }, 1000)
    } else {
      toast.error(deleteTag.data.deleteTag.statusMessage, ToastStyle)
    }
  }

  const GetDate = epoche => {
    // Create a new Date object with the timestamp (multiply by 1000 to convert to milliseconds)
    const date = new Date(epoche * 1000)

    // Format the date as desired
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${date
      .getDate()
      .toString()
      .padStart(2, '0')}`

    return formattedDate
  }

  console.log(totalLists > 0, totalLists === tagsList.length, 'akjbcskjadsc') // Output: "2024-04-30"

  const loadMore = async () => {
    if (filters.mode === 'TFIDB') {
      delete filters.tagType
    }

    filters.from = tagsList.length
    const data = await GetAutoSuggestionsForTagsService(filters)
    console.log(data, 'aScdatadatadatadataadsc')
    const newData = data.data.map(item => {
      if (filters.mode === 'TFIDB') {
        const { PK, SK, mode, tagType, __typename, ...rest } = item
        return rest
      }

      const { PK, SK, mode, __typename, ...rest } = item
      return rest
    })
    setTotalLists(data.total)
    setTagsList([...tagsList, ...data.data])
    setHeaders(Object.keys(newData && newData[0])) // Assuming all objects have the same keys
  }

  useEffect(() => {
    getData()
  }, [filters])
  console.log(tagsList.length, totalLists, tagsList.length !== totalLists, 'akjsdbchjads')
  return (
    <div className='p-2'>
      <div className='d-flex justify-content-between'>
        <label className='mt-3 mb-4'>All Tags</label>
        <button
          className='btn btn-primary '
          style={{ height: '2.5rem', textDecorationLine: 'none' }}
        >
          <a
            style={{ textDecoration: 'none' }}
            className='text-white'
            // target='_blank'
            href='/createTag'
          >
            Create Tag
          </a>
        </button>
      </div>
      <div className='d-flex gap-4 flex-wrap align-items-center'>
        {/* <div className='d-flex gap-1'>
          <label>Mode:</label>
          <select name='mode' value={filters.mode} onChange={handleFilterChange}>
            <option value='Admin'>Admin</option>
            <option value='TFIDB'>TFIDB</option>
          </select>
        </div> */}
        <div className='d-flex gap-1'>
          <label>Search:</label>
          <input
            placeholder='Enter Tag Name'
            type='text'
            name='search'
            value={SearchedInput}
            onChange={handleFilterChange}
          />
          <span className='bg-blue p-1 rounded cursor-pointer' onClick={() => clearSearch()}>
            <MdOutlineClear />
          </span>
        </div>
        <div className='d-flex gap-1'>
          <label>Tag Type:</label>
          <select
            disabled={filters.mode === 'TFIDB'}
            name='tagType'
            value={filters.tagType}
            onChange={handleFilterChange}
          >
            <option value='good'>Good</option>
            <option value='bad'>Bad</option>
          </select>
        </div>
        {/* <div className='d-flex gap-1'>
          <label>Content Type:</label>
          <select name='contentType' value={filters.contentType} onChange={handleFilterChange}>
            <option value='movies'>Movies</option>
            <option value='person'>Person</option>
          </select>
        </div> */}
      </div>
      <div className='d-flex mt-4 flex-wrap'>
        {contentTypesForTags.map((item, index) => (
          <div
            name='TypeWithGoodBad'
            className={` border border-black px-2 py-1 ${
              item.name === selectedTab ? 'bg-blue' : ''
            }`}
            style={{ cursor: 'pointer' }}
            value={item}
            onClick={() => handleFilterChangeForTabs(item, filters.tagType)}
            key={index}
          >
            {item.name}
          </div>
        ))}
      </div>
      {tagsList && tagsList.length > 0 ? (
        <>
          <table className='mt-4'>
            <thead>
              <tr className='justify-content-center align-items-center'>
                <th className='text-center px-2'>S.No</th>
                <th className='text-center px-4'>Actions</th>
                {headers.map((header, index) => (
                  <th className='text-center px-5' key={index}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tagsList.length > 0 &&
                tagsList.map((item, rowIndex) => (
                  <>
                    <tr key={rowIndex}>
                      <td className='py-2'>{rowIndex + 1}</td>
                      <td className='py-2'>
                        <a
                          target='_blank'
                          href={`/editTags?item=${encodeURIComponent(JSON.stringify(item))}`}
                          className='border mr-1 p-1 border-black rounded text-dark cursor-pointer '
                          rel='noreferrer'
                        >
                          <MdEdit />
                        </a>
                        <span
                          className='border mr-1 p-1 border-black rounded cursor-pointer'
                          onClick={() => YesRemovetag(item)}
                        >
                          <MdDelete />
                        </span>
                      </td>
                      {headers.map((header, colIndex) => (
                        <td className='py-2' key={colIndex}>
                          {header === 'createdTime' || header === 'lastModifiedTime'
                            ? GetDate(item[header])
                            : item[header]}
                        </td>
                      ))}
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
          {tagsList.length !== totalLists && (
            <button className='btn btn-primary mt-2' onClick={() => loadMore()}>
              Load More
            </button>
          )}
        </>
      ) : (
        <div className='mt-5'>No Tag Lists Found</div>
      )}
    </div>
  )
}

export default AllTags
